import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["id"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactSlider from 'react-slider';
import SliderLabel from './SliderLabel';
import { SliderMixin, SliderTrackMixin, SliderThumbMixin } from '../../mixins/components/SliderMixin';
export var StyledSlider = /*#__PURE__*/styled(ReactSlider).withConfig({
  displayName: "StyledSlider",
  componentId: "c11n-8-64-0__sc-30wgsf-0"
})(["", ""], SliderMixin);
export var StyledSliderThumb = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledSliderThumb",
  componentId: "c11n-8-64-0__sc-30wgsf-1"
})(["", ""], SliderThumbMixin);
export var StyledSliderTrack = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledSliderTrack",
  componentId: "c11n-8-64-0__sc-30wgsf-2"
})(["", ""], SliderTrackMixin);
/**
 * A custom slider component build on top of
 * [`react-slider`](https://github.com/zillow/react-slider)
 * (see the [example page](https://zillow.github.io/react-slider/)
 * for full props documentation).
 *
 * See also [`Range`](#/Form%20components?id=range), a more restrictive native
 * implementation of a slider.
 *
 * ##### Theming
 * * `StyledSlider`
 * * `StyledSliderLabel`
 * * `StyledSliderThumb`
 * * `StyledSliderTrack`
 *
 * @since 6.12.0
 */

var Slider = function Slider(_ref) {
  var id = _ref.id,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledSlider, _extends({
    id: id,
    thumbClassName: id + "-thumb"
  }, props));
};

Slider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The id of the slider. This is also used to generate ids and classNames for
   * accessibility purposes.
   */
  id: PropTypes.string.isRequired,

  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),

  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  min: PropTypes.number,

  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  max: PropTypes.number,

  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  step: PropTypes.number,

  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  onChange: PropTypes.func,

  /** @ignore */
  renderThumb: PropTypes.func,

  /** @ignore */
  renderTrack: PropTypes.func,

  /** @ignore */
  pearling: PropTypes.bool
} : {};
Slider.defaultProps = {
  /* eslint-disable zillow/react/prop-types */
  renderThumb: function renderThumb(props, state) {
    return /*#__PURE__*/React.createElement(StyledSliderThumb, _extends({}, props, {
      "aria-labelledby": props.key
    }), /*#__PURE__*/React.createElement(SliderLabel, {
      id: props.key
    }, props['aria-valuetext'] || state.valueNow));
  },

  /* eslint-enable zillow/react/prop-types */
  renderTrack: function renderTrack(props, state) {
    return /*#__PURE__*/React.createElement(StyledSliderTrack, _extends({}, props, {
      trackState: state
    }));
  },
  pearling: true
};
export default Slider;